"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function customStringValidation() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    minWords = _ref.minWords,
    maxWords = _ref.maxWords,
    minCharsPerWord = _ref.minCharsPerWord,
    maxCharsPerWord = _ref.maxCharsPerWord;
  if (!value) return new classes_1.ValidationResult(true);
  var words = value.split(' ');
  var wordsCount = words.length;
  if (!!minWords && wordsCount < minWords) {
    return new classes_1.ValidationResult(false, "O campo precisa ter pelo menos ".concat(minWords, " palavras"));
  }
  if (!!maxWords && wordsCount > maxWords) {
    return new classes_1.ValidationResult(false, "O campo precisa ter no m\xE1ximo ".concat(maxWords, " palavras"));
  }
  if (!!minCharsPerWord || maxCharsPerWord) {
    var _iterator = _createForOfIteratorHelper(words),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var word = _step.value;
        var wordLength = word.length;
        if (!!minCharsPerWord && wordLength < minCharsPerWord) {
          return new classes_1.ValidationResult(false, "As palavras precisam ter pelo menos ".concat(minCharsPerWord, " caracteres."));
        }
        if (!!maxCharsPerWord && wordLength > maxCharsPerWord) {
          return new classes_1.ValidationResult(false, "As palavras precisam ter no m\xE1ximo ".concat(minCharsPerWord, " caracteres."));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return new classes_1.ValidationResult(true);
}
exports.default = new classes_1.Validator(customStringValidation);